<template>
  <div class="every-day-info-content">
    <div class="back clear-fix">
      <div class="text" @click="back">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-fanhui1" />
        </svg>
        返回报表
      </div>
    </div>
    <!-- :summary-method="getSummaries"
    show-summary-->
    <div class="every-day-info-table-content">
      <el-table :data="tableData" height="100%" >
        <el-table-column :resizable="false" prop="onlyDay" label="日期" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="realAmount" label="球台收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="reserveAmount" label="球台预定" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="otherAmount" label="会员结账" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="waterAmount" label="水机收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="goodsAmount" label="商品收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="signAmount" label="报名收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="vipAmount" label="充值收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="writeOffAmount" label="销账金额" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="freeSheetAmount" label="免单金额" align="center"></el-table-column>
        <!-- <el-table-column :resizable="false" prop="totalCount" label="营业单数" align="center"></el-table-column> -->
        <el-table-column :resizable="false" prop="totalRealAmount" label="总营业额" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="realTotal" label="实际总收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="lineAmount" label="线上收入" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="unlineAmount" label="线下收入" align="center"></el-table-column>
      </el-table>
      <div class="bottom-pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageLimit"
          layout="prev, pager, next, jumper"
          :total="totalSize"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
  props: ["timeSlotValue"],
  data() {
    return {
      tableData: [],
      currentPage: 1, //当前页码
      pageLimit: 20, //每页数量
      totalSize: 0
    };
  },
  methods: {
    back() {
      this.$emit("showInfocb");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "汇总";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += " 元";
        } else {
          sums[index] = "-";
        }
      });

      return sums;
    },
    handleCurrentChange() {
      //console.log(`当前页: ${val}`);
      this.initData();
    },
    initData() {
      let bizContent = {
        pageQueryDto: {
          start: (this.currentPage - 1) * this.pageLimit,
          limit: this.pageLimit
        }
      };
      //console.log(this.timeSlotValue);
      if (this.timeSlotValue) {
        bizContent.beginDate = this.timeSlotValue[0];
        bizContent.endDate = this.timeSlotValue[1];
      }
      response(requstsMethod.fun_Get_Report_List_Detail_Account, bizContent)
        .then(data => {
          console.log(data);
          this.totalSize = data.totalCount;
          //console.log(this.tableData);
          data.dataList.forEach(item => {
            item.onlyDay = item.day.split(" ")[0];
            //会员收入 线下+线上非会员   不包含会员
            if (!item.realAmount) {
              item.realAmount = 0;
            }
            //预定
            if (!item.reserveAmount) {
              item.reserveAmount = 0;
            }
            //会员
            if (!item.otherAmount) {
              item.otherAmount = 0;
            }
            //商品
            if (!item.goodsAmount) {
              item.goodsAmount = 0;
            }
            //报名
            if (!item.signAmount) {
              item.signAmount = 0;
            }
            //会员充值
            if (!item.vipAmount) {
              item.vipAmount = 0;
            }
            //销账
            if (!item.writeOffAmount) {
              item.writeOffAmount = 0;
            }
            //免单
            if (!item.freeSheetAmount) {
              item.freeSheetAmount = 0;
            }
            //娃娃机金额
            if(!item.toyAmount) item.toyAmount = 0;
            //货柜金额
            if(!item.cabinetAmount) item.cabinetAmount = 0;
            //水机金额
            if(!item.waterAmount) item.waterAmount = 0;
            item.lineAmount = parseFloat(    //线上收入
                item.realAmount +         //球桌收入
                item.goodsAmount +      //商品收入
                item.vipAmount +        //会员充值收入
                item.signAmount +       //报名收入
                item.reserveAmount +      //预定收入
                item.toyAmount +        //娃娃机收入
                item.cabinetAmount +    //货柜收入
                item.waterAmount        //水机收入
            ).toFixed(2);
            item.unlineAmount = 0;       //线下收入
            if (item.realUnlineAmount) {
              //item.realUnlineAmount = parseFloat(item.realUnlineAmount).toFixed(2)
              item.unlineAmount += item.realUnlineAmount;
              item.realAmount += item.realUnlineAmount;
              item.unlineAmount = item.unlineAmount.toFixed(2) - 0
              item.realAmount = item.realAmount.toFixed(2) - 0
            }
            if (item.goodsUnlineAmount) {
              //item.goodsUnlineAmount = parseFloat(item.goodsUnlineAmount).toFixed(2)
              item.unlineAmount += item.goodsUnlineAmount;
              item.goodsAmount += item.goodsUnlineAmount;
              item.unlineAmount = item.unlineAmount.toFixed(2) - 0
              item.goodsAmount = item.goodsAmount.toFixed(2) - 0
            }
            item.totalRealAmount =
              item.realAmount +       //球桌收入
              item.goodsAmount +      //商品收入
              item.vipAmount +        //会员充值收入
              item.signAmount +       //报名收入
              item.reserveAmount +    //预定收入
              item.otherAmount +      
              item.waterAmount +       //水机收入
              item.writeOffAmount +   //销账金额
              item.toyAmount +        //娃娃机收入
              item.cabinetAmount +    //货柜收入
              item.freeSheetAmount;   //免单金额
            item.totalRealAmount.toFixed(2);
            //+billiardsStatementAccountTotalDetailed.realUnlineAmount+billiardsStatementAccountTotalDetailed.goodsUnlineAmount).toFixed(2)}}
            item.realTotal = parseFloat(    //实际总收入
              item.totalRealAmount -
                item.otherAmount -
                item.writeOffAmount -
                item.freeSheetAmount //item.vipAmount -item.writeOffAmount - item.freeSheetAmount
            ).toFixed(2);
            item.unlineAmount = parseFloat(item.unlineAmount).toFixed(2);
            item.realAmount = parseFloat(item.realAmount).toFixed(2);
            item.totalRealAmount = parseFloat(item.totalRealAmount).toFixed(2);
          });
          this.tableData = data.dataList;
          console.log(this.tableData,'报表数据')
        })
        .catch(err => {});
    }
  },
  created() {
    this.initData();
  }
};
</script>

<style lang="scss">
.every-day-info-content {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: #3E3E3E;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Heavy;
  font-weight: 800;
  text-align: center;
  color: #fff;
  box-shadow: 5px 5px 5px -3px #000 inset;
  .back {
    width: calc(100% - 16px);
    height: 50px;
    margin: 8px 8px;
    box-shadow: 0px 0px 5px #000;
    .text {
      width: 116px;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      float: left;
      margin-left: 18px;
      background: #FF8B3E;
      cursor: pointer;
      border-radius: 2px;
      margin-top: 10px;
      .icon {
        font-size: 18px;
      }
    }
    //width: 120px;
    //height: 30px;
    //margin: 20px 0;
  }
  .every-day-info-table-content{
    height: calc(100% - 76px);
    width: calc(100% - 16px);
    margin: 0 8px;
    padding: 8px;
    box-shadow: 0px 0px 5px #000;
    .bottom-pagination {
      position: absolute;
      bottom: 30px;
      right: 20px;
      .el-pagination {
        button{
          background: #3E3E3E;
          box-shadow: 0px 0px 5px #000;
          width: 30px;
          height: 30px;
          color: #fff;
        }
        .el-pager{
          .number{
            background: #3E3E3E;
            width: 30px;
            height: 30px;
            box-shadow: 0px 0px 5px #000;
            color: #fff;
          }
          .active{
            background: #007CFF;
          }
        }
        .el-pagination__jump{
          color: #fff;
          .el-input{
            .el-input__inner{
              background: #3E3E3E;
              border: none;
              box-shadow: 0px 0px 5px #000 inset;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .el-table {
    font-size: 20px;
    border: 1px solid #566979;
    background: #3E3E3E;
    .el-table__header-wrapper {
      .el-table__header {
        thead {
          color: #fff;
          tr {
            th {
              color: #fff;
              font-size: 14px;
              height: 30px;
              padding: 0;
              background: #3E3E3E;
              border-bottom: 1px solid #566979;
              border-right: 1px solid #566979;
            }
          }
        }
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tbody {
          .el-table__row {
            td {
              color: #fff;
              font-size: 14px;
              height: 30px;
              padding: 0;
              background: #3E3E3E;
              border-bottom: 1px solid #566979;
              border-right: 1px solid #566979;
              .el-button {
                font-size: 20px;
                width: 140px;
              }
              .el-date-editor.el-input,
              .el-date-editor.el-input__inner {
                width: 135px;
              }
              .goto-text {
                margin: 0 10px;
              }
            }
          }
          .el-table__row:hover{
            td{
              background: #566979;
            }
          }
        }
      }
    }
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #d5cfc3;
  }
  .el-table--border {
    border-right: none;
    border-bottom: none;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #d5cfc3;
  }
  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid #d5cfc3;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    content: "";
    position: absolute;
    background-color: #3E3E3E;
    z-index: 1;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    content: "";
    position: absolute;
    background-color: #3E3E3E;
    z-index: 1;
  }
}
</style>